import { ChatMessage, type ChatMessageConstructorArgs } from './chat-message';

type TextChatMessageConstructorArgs = Pick<TextChatMessage, 'body'> & ChatMessageConstructorArgs;

/** Text chat message. */
export class TextChatMessage extends ChatMessage {
  /** Body. */
  public readonly body: string;

  public constructor(data: TextChatMessageConstructorArgs) {
    super(data);
    this.body = data.body;
  }

  /**
   * Edit text message.
   * @param newBody New body.
   */
  public async edit(newBody: string): Promise<TextChatMessage> {
    const message = await this.twilioMessage.updateBody(newBody);
    return new TextChatMessage({ body: newBody, twilioMessage: message });
  }
}
